module.exports = __webpack_public_path__ + "img/headshot2.4a1d38c2.jpg";